export { MaxWidthLayout } from './MaxWidthLayout';
export type { MaxWidthLayoutProps } from './MaxWidthLayout';
